import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { globalActions } from "./store/actions/global.action";
import { lssetItem } from "./helpers/localStorageHelper";
import { getKey } from "./helpers/UrlHelper";
import { SplashScreen } from "./cms/components/UI/SplashScreen/SplashScreen";

class RedirectUser extends React.Component {
  state = {
    allowed: false,
    to: "",
    fetched: false
  };
  componentDidMount() {
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    const userGuid = params.get(getKey('token1', params));
    const userId = params.get(getKey('token2', params));
    const redirectUrl = params.get(getKey('redirectUrl', params));

    if (userGuid && redirectUrl) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userGuid, userId, redirectUrl })
      };

      fetch(`./api/authentication/token`, requestOptions)
        .then(res => res.json())
        .then(token => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          lssetItem(token, "user");
          this.props.dispatch(globalActions.showMenu(false));
          this.props.dispatch(globalActions.updateUserToken());
          this.setState({ to: redirectUrl, allowed: true, fetched: true });
        })
        .catch(err => {
          //navigate back or something
        });
    }
  }
  render() {
    const { allowed, fetched, to } = this.state;
    if (!fetched) {
      return <SplashScreen />;
    }
    if (fetched && allowed) {
      return <Redirect to={to} />;
    }
  }
}

export default connect()(RedirectUser);
